import { EMPTY_STRING } from "../../common/constants/common.constants";
import {
  ApplicationStatus,
  GovernanceConfigurationType,
} from "../../common/enums/clubs-wizard.enum";
import {
  IClubDto,
  ICreateClubWizardForm,
} from "../../common/interfaces/clubs-wizard.interface";
import { monkeMint } from "../../solana/common/utilities";

//TODO@milica-monke-merge: For main app community mint addres is mint, for monke monkeMint
export function mapFormValuesToDto(
  values: ICreateClubWizardForm,
  clubAddress: string,
  realmAddress: string,
  ownerPubKey: string,
  signedTransaction: string
): IClubDto {
  return {
    signedTransaction: signedTransaction,
    ownerAddress: ownerPubKey,
    address: clubAddress,
    realmAddress: realmAddress,
    name: values.clubName,
    description: values.clubDescription,
    imageBase64: values.clubImage,
    email: values.clubEmail,
    applicationStatus:
      values.governance === GovernanceConfigurationType.ProjectFundraise
        ? ApplicationStatus.Closed
        : values.clubApplicationStatus,
    discord: values.discord,
    communityMintAddress:
      values.collectionMintAddress !== EMPTY_STRING
        ? values.nftMintAddress
        : monkeMint.toString(),
    instagram: values.instagram,
    linkedin: values.linkedin,
    reddit: values.reddit,
    tags: values.clubTags,
    telegram: values.telegram,
    tiktok: values.tiktok,
    twitter: values.twitter,
  };
}
